import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { clearLoginFailedErrorMessage, loginFailed } from '@redux/actions/singleSignOn';
import { generateRegisterLoginError } from '@redux/epic/singleSignOn/utils';
import { postAsObservable } from '@services/genericService';

import { EVENT_METHOD } from '../../../../utils';

const GET_LOGIN_OTP_ENDPOINT = '/OTP/GetOTPPhoneLogin';

export const GET_LOGIN_OTP_USE_FOR_LOGIN_KEY = 'login';

export const GET_LOGIN_OTP_USE_FOR_REGISTER_KEY = 'register';

export const useGetLoginOTP = () => {
  const dispatch = useDispatch();

  return useCallback(
    (phoneValue, useFor = GET_LOGIN_OTP_USE_FOR_LOGIN_KEY) =>
      new Promise((resolve, reject) => {
        const params = {
          phoneNumber: phoneValue?.trim()
        };

        return from(postAsObservable(GET_LOGIN_OTP_ENDPOINT, params))
          .pipe(
            map((res) => {
              if (res.data?.StatusCode === 0 && res.data?.Result) {
                if (useFor === GET_LOGIN_OTP_USE_FOR_LOGIN_KEY) dispatch(clearLoginFailedErrorMessage());

                return resolve(true);
              } else {
                if (useFor === GET_LOGIN_OTP_USE_FOR_LOGIN_KEY) {
                  dispatch(loginFailed(generateRegisterLoginError(res.data?.StatusReason || 'Failed', EVENT_METHOD.email)));

                  return resolve(false);
                } else {
                  return reject(res.data?.StatusReason);
                }
              }
            })
          )
          .subscribe({
            error: (error) => {
              if (useFor === GET_LOGIN_OTP_USE_FOR_LOGIN_KEY) {
                dispatch(loginFailed(generateRegisterLoginError(error?.message || 'Failed', EVENT_METHOD.email)));

                return resolve(false);
              } else {
                return reject(error?.message || 'Failed');
              }
            }
          });
      }),
    []
  );
};
